import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix INR icon. Exported from Figma (Bombiix 2026). */
const INRIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <defs>
      <clipPath id="inr-icon-clip">
        <rect width="8" height="10.6667" fill="white" transform="translate(6 4.66602)" />
      </clipPath>
    </defs>
    <g>
      <g clipPath="url(#inr-icon-clip)">
        <path
          d="M6 5.33401C6 5.33401 7.16176 5.33401 8.33333 5.33401M11.3333 16.0007L6.66667 11.334C6.66667 11.334 7.66667 11.334 8.33333 11.334C9 11.334 12 11.3752 12 8.33401C12 5.29282 9 5.33401 8.33333 5.33401M14 5.33401C14 5.33401 10.286 5.33401 8.33333 5.33401M6 8.33401H14"
          stroke="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default INRIcon;
